import React from 'react';
import { Container } from 'react-bootstrap';
import AppraisalView from '../components/AppraisalView';
import Layout from '../../../components/Layout';

const AppraisalViewPage = () => {
  return (
    <Layout>
      <AppraisalView />
    </Layout>
    
  );
};

export default AppraisalViewPage;
